class FeatureFlagService {
  public config: {
    SUPER_ADMIN_ENABLED: boolean;
  };

  private _FEATURE_FLAGS = [
    {
      env: "VITE_FF_SUPER_ADMIN_ENABLED",
      config: "SUPER_ADMIN_ENABLED" as keyof typeof this.config,
    },
  ];

  public FEATURE_FLAGS = this._FEATURE_FLAGS.map((ff) => ff.config);

  constructor() {
    this.config = {
      SUPER_ADMIN_ENABLED: false,
    };

    console.log(import.meta.env);

    this._FEATURE_FLAGS.forEach((flag) => {
      if (!import.meta.env[flag.env]) {
        console.warn(`${flag.env} is not defined`);
      }
      this.config[flag.config] = import.meta.env[flag.env] === "true";
    });
  }

  get(key: keyof typeof this.config) {
    return this.config[key];
  }
}

export default FeatureFlagService;
